import styled from 'styled-components';

export const S = {
  FormContainer: styled.div`
    padding: 0 70px;
  `,
};
